import { c as _c } from "react/compiler-runtime";
import type { ScoreBand, SentilinkReasonCode } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const scoreToColor: Record<ScoreBand, string> = {
  low: 'text-success',
  medium: 'text-warning',
  high: 'text-error'
};
type ScoreProps = {
  score: number;
  scoreBand: ScoreBand;
  reasonCodes: SentilinkReasonCode[];
  title: string;
};
const Score = t0 => {
  const $ = _c(38);
  const {
    score,
    scoreBand,
    reasonCodes,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.riskSignals.drawer.sentilink.score"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] !== reasonCodes || $[2] !== score || $[3] !== scoreBand || $[4] !== t || $[5] !== title) {
    const sortedReasonCodes = reasonCodes.sort(_temp);
    const scoreColor = scoreToColor[scoreBand];
    t6 = "flex flex-col border border-solid rounded border-tertiary";
    let t8;
    if ($[12] !== title) {
      t8 = <span className="text-label-1 text-secondary">{title}</span>;
      $[12] = title;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    const t9 = `text-heading-1 ${scoreColor}`;
    let t10;
    if ($[14] !== score || $[15] !== t9) {
      t10 = <span className={t9}>{score}</span>;
      $[14] = score;
      $[15] = t9;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    if ($[17] !== t10 || $[18] !== t8) {
      t7 = <div className="flex flex-col px-5 py-4 border-b border-solid border-tertiary">{t8}{t10}</div>;
      $[17] = t10;
      $[18] = t8;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    t4 = "flex flex-col gap-4 p-5";
    let t11;
    if ($[20] !== t) {
      t11 = t(_temp2);
      $[20] = t;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== t11) {
      t12 = <span className="text-label-2">{t11}</span>;
      $[22] = t11;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    let t13;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <hr className="border-t border-tertiary" />;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    if ($[25] !== t12) {
      t5 = <div className="flex flex-col gap-3">{t12}{t13}</div>;
      $[25] = t12;
      $[26] = t5;
    } else {
      t5 = $[26];
    }
    t2 = "flex flex-col gap-5";
    t3 = sortedReasonCodes.map(_temp3);
    $[1] = reasonCodes;
    $[2] = score;
    $[3] = scoreBand;
    $[4] = t;
    $[5] = title;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[27] !== t2 || $[28] !== t3) {
    t8 = <div className={t2}>{t3}</div>;
    $[27] = t2;
    $[28] = t3;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== t4 || $[31] !== t5 || $[32] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[30] = t4;
    $[31] = t5;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== t6 || $[35] !== t7 || $[36] !== t9) {
    t10 = <div className={t6}>{t7}{t9}</div>;
    $[34] = t6;
    $[35] = t7;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
};
export default Score;
function _temp(a, b) {
  return Number(a.rank) - Number(b.rank);
}
function _temp2($) {
  return $.detectedReasonCodes;
}
function _temp3(reasonCode) {
  return <div key={reasonCode.code} className="flex flex-col gap-1"><span className="text-label-2">{reasonCode.code}</span><span className="text-body-2">{reasonCode.explanation}</span></div>;
}